import { useSelector } from "react-redux";
import colors from "../../../../constants/colorConstants";
import BaseHeading from "../../../../baseComponents/baseHeading.js";
import BaseInput from "../../../../baseComponents/baseInput.js";
import BaseButton from "../../../../baseComponents/baseButton.js";
import { Container, Row, Column, Col } from "reactstrap";
import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  actions as userActions,
  asyncActions as asyncUserActions,
} from "../../../../store/slices/userSlice.js";
import { asyncActions as successAsyncActions } from "../../../../store/slices/successSlice.js";
import useBootstrap from "../../../../customHooks/useBootstrap";
import useColors from "../../../../customHooks/useColors";

const ChangePasswordComponent = () => {
  ////////////////////////////////////////////////////////////////DISPATCHER
  const dispatch = useDispatch();

  ////////////////////////////////////////////////////////////////REDUX STATES
  const [currentColors] = useColors();

  ////////////////////////////////////////////////////////////////CONSTANTS

  const {trashold4} = useBootstrap();

  ////////////////////////////////////////////////////////////////LOCAL STATES

  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [repeatedNewPassword, setRepeatedNewPassword] = useState("");
  const [errorMsg, setErrorMsg] = useState("");

  ///////////////////////////////////////////////////////////////////EFFECTS
  /*
    clear errors on mount
  */
  useEffect(() => {
    clearUserError();
  }, []);

  ////////////////////////////////////////////////////////////////HANDLING FUNCTIONS

  const handleCurrentPasswordChange = (e) => {
    clearUserError();
    setCurrentPassword(e.target.value);
  };

  const handleNewPasswordChange = (e) => {
    clearUserError();
    setNewPassword(e.target.value);
  };

  const handleRepeatPasswordChange = (e) => {
    clearUserError();
    setRepeatedNewPassword(e.target.value);
  };

  const handleEnter = (e) => {
    if (e.key === 'Enter') {
      changePassword();
    }
  }

  ////////////////////////////////////////////////////////////////METHODS

  const clearUserError = () => {
    setErrorMsg("");
  };

  const changePassword = async () => {
    const response = await dispatch(
      asyncUserActions.changePassword({
        currentPasword: currentPassword,
        newPassword: newPassword,
        repeatedNewPassword: repeatedNewPassword,
        setErrorMsg: setErrorMsg
      })
    );

    console.log(response)

   
  };

  ////////////////////////////////////////////////////////////////STYLE
  const styles = {
    mainContainer: {
      backgroundColor: currentColors.septenary,
      padding: "1em",
      display: "flex",
      flexDirection: "column",
      gap: "1em",
      width: "100%",
    },
  };

  return (
    <Container 
      className="p-0"
      style={{ marginTop: "1em" }}
      onKeyUp={(e) => {
        handleEnter(e);
      }}
    >
      <Row className="g-0">
        <Col {...trashold4}>
          <div style={styles.mainContainer}>
            <BaseHeading h3 bold>
              changePassword
            </BaseHeading>
            <BaseInput
              value = {currentPassword}
              type="password"
              placeholder="currentPassword"
              onChange={handleCurrentPasswordChange}
            />
            <BaseInput
              value = {newPassword}
              type="password"
              placeholder="newPassword"
              onChange={handleNewPasswordChange}
            />
            <BaseInput
              value = {repeatedNewPassword}
              type="password"
              placeholder="repeatNewPassword"
              onChange={handleRepeatPasswordChange}
            />
            <BaseButton
              error={errorMsg}
              onClick={() => {
                changePassword();
              }}
            >
              save
            </BaseButton>
          </div>
        </Col>
        <Col {...trashold4}></Col>
        <Col {...trashold4}></Col>
      </Row>
    </Container>
  );
};

export default ChangePasswordComponent;
